import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"

const HamburgerIconImage = () => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "share-icon-twitter.png" }) {
        childImageSharp {
          fluid(maxWidth: 80, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)
  return (
    <Img
      style={{
        width: "40px",
      }}
      fluid={data.placeholderImage.childImageSharp.fluid}
    />
  )
}

export default HamburgerIconImage
